export const SoloPage = ({ children }) => {
  return children;
};
